import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Wrapper } from "../Wrapper";

export const GiftingBackgroundPatternContainer = styled.div`
  background: url(/images/app/gifting/repeating_tile.svg),
    ${(props) => props.theme.colors.forest};
  background-repeat: repeat;
`;

const HeaderContainer = styled(GiftingBackgroundPatternContainer)`
  display: flex;
  justify-content: center;
  min-height: 300px;
  overflow: hidden;
  position: relative;
  position: relative;

  @media ${(props) => props.theme.bp.tabletUp} {
    min-height: 420px;
  }
`;

const Title = styled.h2`
  color: ${(props) => props.theme.colors.charcoal};
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 0px;
  overflow-wrap: break-word;
  line-height: 1.4;

  @media ${(props) => props.theme.bp.tabletUp} {
    font-size: 36px;
  }
`;

const Subtitle = styled("h2")`
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: ${(props) => props.theme.colors.charcoal};
  opacity: 1;
  line-height: 1.4;

  @media ${(props) => props.theme.bp.tabletUp} {
    font-size: 18px;
    max-width: 780px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Text = styled.h2`
  color: ${(props) => props.theme.colors.charcoal};
  text-align: center;
  font-size: 18px;
  line-height: 1.4;
`;

type ContentContainerProps = {
  gutterLarge?: boolean;
  gutterMedium?: boolean;
};

const ContentWrapper = ({ gutterMedium, gutterLarge, ...props }: any) => (
  <Wrapper isLarge {...props} />
);

const ContentContainer = styled(ContentWrapper)<ContentContainerProps>`
  padding-top: 60px;

  ${(props) =>
    props.gutterMedium &&
    css`
      padding-bottom: 80px;
    `}

  ${(props) =>
    props.gutterLarge &&
    css`
      padding-bottom: 60px;

      @media ${props.theme.bp.tabletUp} {
        padding-bottom: 120px;
      }
    `}
`;

const GiftingPageWrapper = styled.div`
  background: ${({ theme }) => theme.colors.snowdrop};
`;

export const GiftingPage = ({
  children,
  headerContent,
}: {
  children: React.ReactNode;
  headerContent: JSX.Element;
}) => {
  return (
    <GiftingPageWrapper>
      <HeaderContainer>{headerContent}</HeaderContainer>
      {children}
    </GiftingPageWrapper>
  );
};

GiftingPage.Title = Title;
GiftingPage.Subtitle = Subtitle;
GiftingPage.Text = Text;
GiftingPage.ContentContainer = ContentContainer;
